import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { getEvent, updateEvent } from '../../../api/events.api';
import SessionEditor from '../../../components/business/session/Editor';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import { IGetEvent } from '../../../models/events.model';

interface IMatch {
  eventNo: string;
}

const SessionEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const eventNo = Number(match.params.eventNo);
  const history = useHistory();
  const location = useLocation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetEvent>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();

  useEffect(() => {
    if (eventNo) {
      execute(getEvent('FR', eventNo));
    }
  }, [eventNo]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/business/session${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    submitExecute(updateEvent('FR', eventNo, data));
  };

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-business-big.svg"
        parentMenu={t('common.menu.business')}
        currentMenu={t('business.session.title3')}
      />
      <SessionEditor data={res?.data} submit={submit} />
    </div>
  );
};

export default SessionEdit;
